import { ICommand } from '../../controller/ICommand';
import { Message } from 'projects/game-utils/src/lib/utils/Message';
import { State } from 'projects/game-utils/src/lib/controller/StateFile';
import { CurrentUSer } from 'projects/game-utils/src/lib/utils/CurrentUser';
import { AlertWindowComponent } from 'projects/game-utils/src/lib/windows/alert-window/alert-window.component';
import { SocketService } from 'projects/game-utils/src/lib/service/socket.service';
import { AbstractGs } from 'projects/game-utils/src/lib/service/AbstractGs';

export class LoginCommand implements ICommand{
    
    chooseModeForm:boolean;

    constructor(private gameService:AbstractGs, private reconnectWindow:AlertWindowComponent, private socketService:SocketService){

    }

    extractPaymentsData( msg:Message ) :void {
        this.gameService.user.setCoins(parseFloat( msg.params[ 4 ] ));
        this.gameService.user.setPaymentRequestId(parseInt( msg.params[ 5 ] ));
    }

    getState():number{
        return State.CHOSE_MODE;
    }

    run(msg:Message, params:Array<any>):void{
        if (Number(msg.params[0]) == 0)
        {
            this.gameService.user = new CurrentUSer(msg.params[2], msg.params[3], msg.params[1]);
            this.socketService.setSender( this.gameService.user.getCurrentUser() );
            //Main.currentUser = this.gameService.user;
            this.extractPaymentsData( msg );
            this.chooseModeForm = true;
        }

        if (Number(msg.params[0]) == 3)
			{
                this.reconnectWindow.showWindow();
				//WindowAlert.showWindow(Application(FlexGlobals.topLevelApplication), ResourceManager.getInstance().getString('checkers', 'login_command.login'), ResourceManager.getInstance().getString('checkers', 'login_command.successfull_login_oponent_disconnected_want_to_wait_question'), new <Function>[reconectYes, reconectNo], new <String>[ResourceManager.getInstance().getString('checkers', 'login_command.join'), ResourceManager.getInstance().getString('checkers', 'login_command.reject')], 500);
                this.gameService.user = new CurrentUSer(msg.params[2], msg.params[3], msg.params[1]);
                this.socketService.setSender( this.gameService.user.getCurrentUser() );
				//Main.currentUser = gameService.user;
				this.extractPaymentsData( msg );
				this.chooseModeForm = true;
			}
    }
}